import { Accordion, Container, Carousel } from "@peracto/peracto-blocks";
import Products from "./ProjectGroupProducts";
export default {
    plugins: {
        content: [Accordion, Carousel, Products],
        layout: [Container],
    },
};
